import {useAPIRest, verifyHttpCode} from "@/common/constants";

export const signInUser = async ({commit}, usuarioSign) => {
  const {usuario, password} = usuarioSign;
  return await useAPIRest(process.env.VUE_APP_NEST_AUTH_LOGIN, 'POST', undefined, {
    usuario: usuario,
    password: password
  }, undefined, 'application/json', 'include').then(resJSON => {
    const {token, requires2FA, statusCode, message} = resJSON;
    if (requires2FA && !resJSON.first_login) {
      localStorage.removeItem('token');
      sessionStorage.setItem('user', JSON.stringify(resJSON));
      sessionStorage.setItem('tempToken', resJSON.tempToken);
      sessionStorage.setItem('2fa_userId', resJSON.userId);
      sessionStorage.setItem('2fa_userEmail', resJSON.userEmail);
      sessionStorage.setItem('2fa_userName', resJSON.userName);
      sessionStorage.setItem('2fa_maskedEmail', resJSON.userEmail);
      sessionStorage.setItem('2fa_maskedEmail', resJSON.userEmail);
      
      delete resJSON.token;
      delete resJSON.statusCode;
      delete resJSON.message;

      return resJSON;
    }

    if (verifyHttpCode(statusCode, 'success')) {
      commit('loginUser', {usuario: resJSON, token: 'Bearer ' + token});
      return {ok: true, first_login: resJSON.first_login, token: token};
    } else return {ok: false, message: message} ;
  });
}

export const checkAuth = async ({commit}) => {
  const tokenStored = localStorage.getItem('token');

  if (!tokenStored) {
    commit('logout');
    return {ok: false, message: 'No hay token en la petición'};
  }

  return await useAPIRest(process.env.VUE_APP_NEST_AUTH_STATUS, 'GET', tokenStored).then(resJSON => {
    const {token, statusCode, message} = resJSON;
    delete resJSON.token;
    delete resJSON.statusCode;
    delete resJSON.message;
    if (verifyHttpCode(statusCode, 'success')) {
      commit('loginUser', {usuario: resJSON, token: 'Bearer ' + token});
      resJSON.ok = true;
      return resJSON;
    } else {
      commit('logout');
      return {ok: false, message, statusCode}
    }
  });
}

export const unregisterUser = ({commit}) => {
  commit('logout');
}